import { FieldFormat, SectionConfig } from "../../types";
import { selectCloudStorage } from "../selectors";
import { getItemKeyByValue, buildOwnLabel } from "./helpers";

const TRACKING_TYPE: FieldFormat = {
  enum: {
    NONE: "trackingEmails.NONE",
    OPEN_EMAIL: "trackingEmails.OPEN_EMAIL",
    OPEN_LINK: "trackingEmails.OPEN_LINK",
    BOTH: "trackingEmails.BOTH",
  },
};

const config: SectionConfig = {
  section: "cloudStorage",
  titleKey: "confirmRuleUpdates.cloudStorageChanges.title",
  selector: selectCloudStorage,
  properties: {
    // Neither `provider` nor `authentication` is reported on its own: the
    // user picks an account, and the three travel together. `storageAccount`
    // is the single row that stands for that choice.
    storageAccount: {
      label: "confirmRuleUpdates.cloudStorageChanges.storageAccount",
      format: { resolve: "storageAccount" },
    },
    // Both hold the balanced account list the form labels the same way:
    // asUsers on Dropbox, userIds everywhere else.
    userIds: {
      label: "cloudStorage.balanced.label",
      getItemKey: getItemKeyByValue,
    },
    asUser: { label: "cloudStorage.asUser.label" },
    asUsers: {
      label: "cloudStorage.balanced.label",
      getItemKey: getItemKeyByValue,
    },
    storeId: {
      label: buildOwnLabel("cloudStorageStoreId"),
      format: { resolve: "store" },
    },
    metadata: {
      label: buildOwnLabel("cloudStorageMetadata"),
      format: { resolve: "metadataTemplate" },
    },
    trackingType: {
      label: "confirmRuleUpdates.cloudStorageChanges.trackingType",
      format: TRACKING_TYPE,
    },
    allManagedUserIds: {
      label: "cloudStorage.storeByUser.label",
      format: "boolean",
    },
    folderSharing: {
      label: "cloudStorage.linkToFolder.title",
      format: { resolve: "folderSharing" },
    },
    linkSecurity: {
      label: "confirmRuleUpdates.cloudStorageChanges.linkSecurity",
      format: { resolve: "securityItem" },
    },
  },
};

export default config;
